import { horario } from './horario'

export function formularioMostrar() {
  const anchoWindow2 = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const urlActual = window.location.origin + window.location.pathname
  jQuery.noConflict();

  if (horario()) {
    if (anchoWindow2 < 768) {
      jQuery.noConflict();
      $('#formulario_chico').modal('show')
      if (urlActual === 'https://gestionpatrimonial.mapfre.es/new/') {
        jQuery.noConflict();
        $('#formulario_normal').modal('show')
      }
    } else {
      jQuery.noConflict();
      $('#formulario_normal').modal('show')
    }
  } else {
    if (anchoWindow2 < 768) {
      jQuery.noConflict();
      $('#formulario_chico').modal('show')
      if (urlActual === 'https://gestionpatrimonial.mapfre.es/new/') {
        jQuery.noConflict();
        $('#formulario_normal').modal('show')
      }
    } else {
      jQuery.noConflict();
      $('#formulario_normal').modal('show')
    }
  }
}
